import { Component, OnInit } from "@angular/core";
import { Navigator } from "../../components/menu/navigator";
import { Platform, PopoverController } from "@ionic/angular";
import { ConfigService } from "src/app/services/config/config.service";

@Component({
  selector: "app-standard-popover",
  templateUrl: "./standard-popover.page.html",
  styleUrls: ["./standard-popover.page.scss"],
})
export class StandardPopoverPage implements OnInit {
  
  public data;
  public basePath = this.config.getConfig().CDN_BASEURL + "/assets/imgs/";
  private isIOSApp: boolean = false;
  private timeoutAutoHide: any;
  private event: any;

  constructor(
    private readonly navigator: Navigator,
    public popoverController: PopoverController,
    public config: ConfigService,
    private platform: Platform
  ) {
    this.data =
      this.navigator?.activePopovers[
        this.navigator.activePopovers.length - 1
      ]?.componentProps?.data;
    if (this.data) this.event = this.data.event;

    this.isIOSApp = this.platform.is("capacitor") && this.platform.is("ios");
  }

  ngOnInit() {
    this.setPopoverPosition();
    this.callAutoHide();
  }

  callAutoHide() {
    if (this.data.isAutoHideEnabled && this.data.isAutoHideTimeout) {
      this.timeoutAutoHide = setTimeout(() => {
        this.popoverController.dismiss();
      }, this.data.isAutoHideTimeout);
    }
  }

  closePopover() {
    clearTimeout(this.timeoutAutoHide);
    this.popoverController.dismiss();
  }

  setPopoverPosition() {
    setTimeout(() => {
      const popover: any = document.querySelector(
        ".standard-notification-popover"
      );
      const popover_view: any = document.querySelector(".popover-viewport");
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      const addMoreLeftSpace = this.isIOSApp && screenWidth >= 780 ? 20 : 10;
      const addMoreTopSpace = screenWidth >= 576 ? 25 : 120;
      const width =
        popover_view.offsetWidth != 0
          ? popover_view.offsetWidth
          : screenWidth <= 990
            ? 320
            : 380;
      const height =
        popover_view.offsetHeight != 0 ? popover_view.offsetHeight : 250;

      popover.style.setProperty(
        "--offset-x",
        -((screenWidth - width) / 2 - addMoreLeftSpace) + "px",
        "important"
      );
      popover.style.setProperty(
        "--offset-y",
        -((screenHeight - height) / 2 - addMoreTopSpace - 20) + "px",
        "important"
      );
    }, 30);
  }
  clickAction() {
    if (!this.event.actionComponent) return;
    return this.navigator.navigateTo(this.event.actionComponent, {
      customModalClass: "custom-shop-model-class-transparent",
      backdropDismiss: true,
    });
  }
}
